export const types = {
    EXECUTE: 'RUN',
    OPEN: 'OPEN'
};